module.exports = __webpack_public_path__ + "img/carousel3.1bc2ed8a.png";